import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
//https://www.npmjs.com/package/@microsoft/signalr

export default class Chats extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            contact: null,
            chats: [],
            loading: true,
            message: '',
            connection: null,
            uploading: [],
            replyTo: null,

            currentRoom: null,
            currentRoomUser: null,
            activeTab: 'supports',
            id_to_remove: null
        }
    }
    async createHub(userId, roomId) {
        try {
            const connection = new HubConnectionBuilder()
                .withUrl("chathub")
                //.configureLogging(LogLevel.Information)
                .build();

            connection.on("ReceiveMessage", (message) => {
                this.state.chats.push(message);
                this.setState({
                    chats: this.state.chats
                });
                this.gotoEnd();
                this.playNotificationSound();
            });

            connection.onclose((e) => {

            });

            await connection.start()
                .catch(err => console.error("SignalR start error: ", err));

            await connection.invoke("CreateConnection", userId, roomId);
            this.state.connection = connection;

        } catch (e) {
            console.error(e);
        }
    }
    handlePaste = (e) => {
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind === 'file') {
                const file = item.getAsFile();
                this.setFile(file);
                break;
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener('paste', this.handlePaste);
    }
    componentDidMount() {
        document.addEventListener('paste', this.handlePaste);
        this.httpPost("api/v1/chat/list", {
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    });
                    var id = this.getCurrentFormId();
                    var defaultContact = null;
                    if (id != 0) {
                        data.contacts.forEach(c => {
                            if (c.id == id) defaultContact = c;
                        })
                    }
                    if (!this.isNull(defaultContact)) this.loadChats(defaultContact);
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    loadChats(contact) {
        if (this.state.connection != null) {
            try {
                this.state.connection.stop();
                this.state.connection = null;
            } catch (err) { console.log(err) }
        }
        this.state.contact = contact;
        this.state.replyTo = null;
        this.httpPost("api/v1/chat/get", {
            chatRoomId: contact.chatRoomId,
            userId: contact.userId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    this.createHub(this.state.data.global.user.id, data.room.id);

                    this.setState({
                        message: '',
                        chats: data.records,
                        currentRoomUser: data.roomUser,
                        currentRoom: data.room,
                        loading: false
                    });
                    this.gotoEnd();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });

    }
    send(e) {
        e.preventDefault();
        if (this.isBlank(this.state.message)) {
            this.showErorrMessage("لطفا متنی وارد نمایید");
            return;
        }
        try {
            if (!this.state.connection) {
                this.showErorrMessage("ارتباط با سامانه متصل نشد. لطفا صفحه را رفرش نمایید");
                return;
            }
            var message = this.state.message;
            this.setState({
                message: '',
                replyTo: null
            });

            this.state.connection.invoke("SendMessage", this.state.currentRoom.id, message, (this.isNull(this.state.replyTo) ? this.getDefaultGuid() : this.state.replyTo.id));

            document.getElementById('chatMessage').value = '';
        } catch (e) {
            console.error(e);
        }
    }
    gotoEnd() {
        var x = setInterval(() => {
            clearInterval(x);
            var t = document.getElementById('nk-chat-panel');
            if (t != null && t != undefined) t.scrollTop = t.scrollHeight;
        }, 500)
    }
    uploadLargFile(selectedFile, id, format) {
        return new Promise((resolve, reject) => {
            const chunkSize = 1 * 1024 * 1024; // 1MB (adjust based on your requirements)
            const totalChunks = Math.ceil(selectedFile.size / chunkSize);
            const chunkProgress = 100 / totalChunks;
            let chunkNumber = 0;
            let start = 0;
            let end = 0;
            const uploadNextChunk = async () => {
                if (chunkNumber <= totalChunks) {
                    if (end == 0) {
                        if (selectedFile.size >= chunkSize) end = chunkSize;
                        else end = selectedFile.size;
                    }
                    if (end > selectedFile.size) end = selectedFile.size;

                    const chunk = selectedFile.slice(start, end);
                    const formData = new FormData();

                    formData.append("file", chunk);
                    formData.append("chunkNumber", chunkNumber);
                    formData.append("totalChunks", totalChunks);
                    formData.append("originalname", id + "." + format);

                    fetch("/api/v1/chat/upload_chunk", {
                        method: "POST",
                        body: formData,
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.status == 0) {
                                this.showErorrMessage(data.message);
                                resolve({ status: false });
                                return;
                            }
                            if (data.status == -1) {
                                window.location.href = "/login";
                                return;
                            }
                            if (data.status == 2) {
                            }
                            var percent = Number((chunkNumber + 1) * chunkProgress);
                            document.getElementById("uploadingPercent_" + id).innerHTML = Math.round(percent) + "% ارسال شده";
                            chunkNumber++;
                            start = end;
                            end = start + chunkSize;
                            uploadNextChunk();
                        })
                        .catch((error) => {
                            this.showErorrMessage("ارسال فایل با خطا مواجه شد. لطفا مجدد ارسال نمایید.");
                            resolve({ status: false });
                        });
                } else {
                    document.getElementById("uploadingPercent_" + id).innerHTML = "0% ارسال شده";
                    resolve({ status: true });
                }
            };

            uploadNextChunk();
        })
    }
    async setFile(file) {
        var id = this.uuidv4();
        var name = file.name;
        var format = name.split(".")[name.split(".").length - 1];
        this.state.uploading.push({
            id: id,
            name: name
        });
        this.setState({ uploading: this.state.uploading });

        var resualt = await this.uploadLargFile(file, id, format);
        if (resualt.status) {
            try {
                await this.state.connection.invoke("SendMedia", this.state.contact.id, id + "." + format, name, (this.isNull(this.state.replyTo) ? this.getDefaultGuid() : this.state.replyTo.id));
            } catch (e) {
                console.error(e);
            }
        }

        var t = [];
        this.state.uploading.forEach(f => {
            if (f.id != id) t.push(f);
        });
        this.setState({ uploading: t });
    }
    getParentChat(parentId) {
        if (this.isNull(parentId)) return null;
        var chat = null;
        this.state.chats.forEach(c => {
            if (c.id === parentId) chat = <div style={{ "background-color": "#f5f6fa", "padding": "0 10px" }}>
                در پاسخ:
                {this.isBlank(c.media) ?
                    <div style={{ "text-overflow": "ellipsis", "white-space": "nowrap", "overflow": "hidden", "height": "20px" }} dangerouslySetInnerHTML={{ __html: c.message.replaceAll('\n', '<br/>') }}></div>
                    :
                    <a style={{ "text-overflow": "ellipsis", "white-space": "nowrap", "overflow": "hidden", "height": "20px" }} href={"/chats/" + c.media} target="_blank">{c.mediaRealName}<br />دانلود فایل</a>
                }
            </div>
        });
        return chat;
    }
    getUnreadChatCount(chatRoomId) {
        var c = 0;
        this.state.data.chatContactCounts.forEach(f => {
            if (f.chatRoomId == chatRoomId) c = f.count;
        })
        return c;
    }
    canSendMessage() {
        if (this.isNull(this.state.currentRoom)) return false;
        if (this.isNull(this.state.currentRoomUser)) return false;
        if (this.state.currentRoom.type === 2 && this.state.currentRoomUser.type !== 2) {
            return false;
        }
        return true;
    }
    setReplyTo(chat) {
        this.setState({ replyTo: chat })
        this.gotoEnd();
    }
    remove() {
        this.httpPost("api/v1/chat/remove", {
            id: this.state.id_to_remove
        })
            .then((data) => {
                if (data.status === -1) window.location.href = '/login';
                if (data.status === 1) {
                    var chat = this.state.chats.find(f => f.id == this.state.id_to_remove);
                    if (chat) {
                        chat.message = 'پیام حذف شده';
                        chat.removed = true;
                    }
                    this.setState({ id_to_remove: null, showConfirmRemove: false });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch((err) => {
                this.showErorrMessage('پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.');
            });
    }
    chatRemove(chatId) {
        this.state.id_to_remove = chatId;
        this.setState({ showConfirmRemove: true });
    }
    chatDone(chat) {
        if (!chat.isMe) return;

        var done = !chat.done;
        this.httpPost("api/v1/chat/done", {
            id: chat.id,
            done: done
        }, false)
            .then((data) => {
                if (data.status === -1) window.location.href = '/login';
                if (data.status === 1) {
                    var chatRecord = this.state.chats.find(f => f.id == chat.id);
                    if (chatRecord)
                        chatRecord.done = done;
                    this.setState({ data: this.state.data });
                } else {
                    this.showErorrMessage(data.message);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
    renderChatMeta(chat) {
        if (chat.removed) return null;
        
        return <ul className="chat-msg-more">
            <li className="d-none d-sm-block">
                <a onClick={e => this.chatDone(chat)} className={(chat.isMe ? "hand" : "") + " text-" + (chat.done ? "success" : "gray")} title={chat.done ? "انجام شده" : "انجام نشده"}><i className="fa fa-check-square"></i></a>
            </li>
            <li className="d-none d-sm-block">
                <a onClick={e => this.setReplyTo(chat)} className="hand btn btn-icon btn-sm btn-trigger"><em className="icon ni ni-reply-fill"></em></a>
            </li>
            <li className="d-none d-sm-block">
                {chat.isMe && <a onClick={e => this.chatRemove(chat.id)} className="hand text-danger" title="حذف این پیام"><i className="fa fa-trash"></i></a>}
            </li>
        </ul>
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="nk-chat">
                            <div className="nk-chat-aside">
                                <div className="nk-chat-aside-body" data-simplebar>
                                    <div className="nk-chat-aside-search">
                                        <div className="form-group">
                                            <div className="form-control-wrap">
                                                <div className="form-icon form-icon-left">
                                                    <em className="icon ni ni-search"></em>
                                                </div>
                                                <input type="text" className="form-control form-round" id="default-03" placeholder="جستجوی مخاطبین" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="nk-chat-list">
                                        <h6 className="title overline-title-alt">مخاطبین و همکاران شما</h6>
                                        <ul className="chat-list">
                                            {this.state.data.contacts.map(contact =>
                                                contact.contactType === 4 && <li className="chat-item">
                                                    <a onClick={e => this.loadChats(contact)} className="hand chat-link chat-open">
                                                        {!this.isBlank(contact.pic) && <div className="chat-media user-avatar">
                                                            <img src={contact.pic} />
                                                        </div>}
                                                        {this.isBlank(contact.pic) && <div className="chat-media user-avatar bg-purple">
                                                            <span>{contact.userName.toString().substr(0, 2)}</span>
                                                            <span className="status dot dot-lg dot-gray"></span>
                                                        </div>}
                                                        <div className="chat-info">
                                                            <div className="chat-from">
                                                                <div className="name">{contact.userName} {this.getUnreadChatCount(contact.id) > 0 && <b className="text-success">({this.getUnreadChatCount(contact.id)} پیام جدید)</b>}</div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            )}
                                            {this.isEmpty(this.state.data.contacts) && <div className="text-center"><div className="text"><p>فعلا گفتگویی برای شما شروع نشده است</p></div></div>}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {!this.isNull(this.state.contact) && <div className="nk-chat-body">
                                <div className="nk-chat-head">
                                    <ul className="nk-chat-head-info">
                                        <li className="nk-chat-body-close">
                                            <a href="#" className="btn btn-icon btn-trigger nk-chat-hide ms-n1"><em className="icon ni ni-arrow-left"></em></a>
                                        </li>
                                        <li className="nk-chat-head-user">
                                            <div className="user-card">
                                                <div className="user-avatar bg-purple">
                                                    {!this.isBlank(this.state.contact.pic) && <img src={this.state.contact.pic} />}
                                                    {this.isBlank(this.state.contact.pic) && <span>{this.state.contact.userName.toString().substr(0, 2)}</span>}
                                                </div>
                                                <div className="user-info">
                                                    <div className="lead-text"><a href={this.getSiteDomain() + "/user/" + this.state.contact.id + "/"}>{this.state.contact.userName}</a></div>
                                                    <div className="sub-text"><span className="d-none d-sm-inline me-1">آنلاین </span></div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div id="nk-chat-panel" className="nk-chat-panel" data-simplebar>
                                    {this.state.chats.map(chat => <div className={!chat.isMe ? "chat is-me" : "chat is-you"}>
                                        <div className="chat-content">
                                            <div className={"chat-bubbles " + (this.isNull(chat.parentId) ? "" : "chat-msg")}>
                                                {this.getParentChat(chat.parentId)}
                                                <div className="chat-bubble">
                                                    {this.isBlank(chat.media) ?
                                                        <div className="chat-msg" dangerouslySetInnerHTML={{ __html: chat.message.replaceAll('\n', '<br/>') }}></div>
                                                        :
                                                        <a className="chat-msg text-center" href={"/chats/" + chat.media} target="_blank">{chat.mediaRealName}<br />دانلود فایل</a>
                                                    }
                                                    {this.renderChatMeta(chat) }
                                                </div>
                                            </div>
                                            <ul className="chat-meta">
                                                {!chat.isMe ? <li>{this.state.contact.userName}</li> : <li>شما</li>}
                                                <li>{chat.date}</li>
                                            </ul>
                                        </div>
                                        {!chat.isMe && <div className="chat-avatar">
                                            <div className="user-avatar bg-purple">
                                                {!this.isBlank(this.state.contact.pic) && <img src={this.state.contact.pic} />}
                                                {this.isBlank(this.state.contact.pic) && <span>{this.state.contact.userName.toString().substr(0, 2)}</span>}
                                            </div>
                                        </div>}
                                    </div>)}
                                </div>
                                <div class="flex flex-col">
                                    {this.state.uploading.map(u => <div class="flex flex-row" style={{ "justify-content": "space-between", "padding": "0 10px", "border-bottom": "1px #edf0f6 solid", "align-items": "center" }}>
                                        <small>{u.userName}</small>
                                        <span id={"uploadingPercent_" + u.id}>0% ارسال شده</span>
                                    </div>)}
                                </div>
                                {!this.isNull(this.state.replyTo) && <div style={{ "background-color": "#f5f6fa", "padding": "0 10px" }}>
                                    پاسخ به پیام:
                                    {this.isBlank(this.state.replyTo.media) ?
                                        <div style={{ "text-overflow": "ellipsis", "white-space": "nowrap", "overflow": "hidden" }} dangerouslySetInnerHTML={{ __html: this.state.replyTo.message.replaceAll('\n', '<br/>') }}></div>
                                        :
                                        <a style={{ "text-overflow": "ellipsis", "white-space": "nowrap", "overflow": "hidden" }} href={"/chats/" + this.state.replyTo.media} target="_blank">{this.state.replyTo.mediaRealName}<br />دانلود فایل</a>
                                    }
                                </div>}
                                <form method="post" onSubmit={e => this.send(e)} className="nk-chat-editor">
                                    <div className="nk-chat-editor-upload  ms-n1">
                                        <button type="submit" className="btn btn-round btn-primary btn-icon"><em className="icon ni ni-send-alt"></em></button>
                                    </div>
                                    <div className="nk-chat-editor-form">
                                        <div className="form-control-wrap">
                                            <textarea id="chatMessage" key={this.state.message} defaultValue={this.state.message} onChange={e => this.state.message = e.target.value} className="form-control form-control-simple no-resize" rows="1" placeholder="متن پیام خود را وارد کنید ..."></textarea>
                                        </div>
                                    </div>
                                    <ul className="nk-chat-editor-tools g-2">
                                        <input ref={fileInput => this.fileInput = fileInput} style={{ "display": "none" }} type='file' onChange={(e) => { this.setFile(e.target.files[0]) }} />
                                        <li><a className="hand" onClick={e => this.fileInput.click()}><em className="icon ni ni-file"></em></a></li>
                                    </ul>
                                </form>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}